import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.923 4.616A1 1 0 0 0 6 4H2l-.117.007A1 1 0 0 0 1 5l.007.117A1 1 0 0 0 2 6h3.242l4.574 16.327a4.5 4.5 0 1 0 6.134 3.498l13.549-3.63.11-.037a1 1 0 0 0 .597-1.188l-.037-.11a1 1 0 0 0-1.188-.597l-13.77 3.689a4.51 4.51 0 0 0-3.407-1.943L6.963 4.73zm2.162 22.531a2.5 2.5 0 1 1 4.83-1.294 2.5 2.5 0 0 1-4.83 1.294m15.97-21.516.044.143L27.946 16.4a2 2 0 0 1-1.271 2.406l-.143.044-10.625 2.847a2 2 0 0 1-2.406-1.272l-.044-.142L10.61 9.656a2 2 0 0 1 1.272-2.405l.142-.044L22.65 4.36a2 2 0 0 1 2.405 1.271M18.82 7.456l4.347-1.164 2.847 10.625-10.625 2.847-2.847-10.625 4.346-1.166 1.295 4.83 1.932-.517z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPurchaseOrders = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPurchaseOrders);
export default Memo;
